import {
  UPLOAD_DOCUMENT,
  SET_UPLOADED_DOCUMENT,
  RESET_UPLOAD_DOCUMENT_STORE,
  SET_DOCUMENT_ID,
  REQUEST_GET_REPORTS_POLICY,
  SET_DOCUMENTUM_ID,
} from 'containers/UploadDocuments/constants';
export const uploadDocument = (uploadFile: any) => ({
  type: UPLOAD_DOCUMENT,
  uploadFile,
});
export const setUploadDocument = (uploadedDocument: any) => ({
  type: SET_UPLOADED_DOCUMENT,
  uploadedDocument,
});

export const setDocumentId = (documentId: string) => ({
  type: SET_DOCUMENT_ID,
  documentId,
});
export const setDocumentumId = (documentumId: any) => ({
  type: SET_DOCUMENTUM_ID,
  documentumId,
});

export const resetUploadDocumentStore = () => ({
  type: RESET_UPLOAD_DOCUMENT_STORE,
});

export const requestGetReportsPolicy = (url: any) => ({
  type: REQUEST_GET_REPORTS_POLICY,
  url,
});
